import { createContext, useContext } from 'react';

/**
 * Extra short codes (key -> label) merged into the `FormHTMLInline` "Short Codes" dropdown.
 * Header rows use the `h:` prefix convention (e.g. `'h:Project Manager': 'h:Project Manager'`).
 *
 * Provided by a specific builder (e.g. the project-list template builder) so its codes appear
 * ONLY inside that builder's editors — proposals and every other editor keep the default list.
 */
export const ShortCodesContext = createContext<Record<string, string> | null>(null);

export function useShortCodes() {
  return useContext(ShortCodesContext);
}
